import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class PlatiService {
    private token!: string;
    private httpOptions: any;

    private basePath = environment.interop.basePath;

    private listDTPlatiURL =
        this.basePath +
        environment.interop.deps.plati.listDT;

    public printChitantaURL =
        this.basePath +
        environment.interop.deps.plati.printChitanta;

    constructor(private http: HttpClient) { }

    listDTPlati() {
        return this.http.post(this.listDTPlatiURL, {});
    }

    setToken(token: string) {
        this.token = token;
        this.httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                Accept: 'application/json',
                Authorization: `Bearer ${this.token}`,
            }),
        };
    }
}
